import { APOSTILLE_STATUS, APOSTILLE_STATUS_SUMMARY_TH } from "@/data/legal-facts";

/**
* Visible, citation-backed status block for the Apostille transition period.
* Rendered on every Apostille / legalisation page so the site never states
* that Thailand issues Apostilles before 28 February 2027.
*/
export function ApostilleStatusNotice({ className = "" }: { className?: string }) {
  return (
    <aside
      className={`rounded-lg border border-amber-300/60 bg-amber-50/70 p-4 text-sm leading-relaxed dark:border-amber-500/30 dark:bg-amber-500/10 ${className}`}
      aria-labelledby="apostille-status-heading"
    >
      <h2 id="apostille-status-heading" className="mb-2 text-base font-semibold">
        สถานะอนุสัญญา Apostille ของประเทศไทย (ตรวจสอบล่าสุด {APOSTILLE_STATUS.verifiedOnTh})
      </h2>
      <p className="answer-summary" data-speakable>
        {APOSTILLE_STATUS_SUMMARY_TH}
      </p>
      <ul className="mt-3 space-y-1">
        <li>
          <strong>ยื่นภาคยานุวัติสาร:</strong> {APOSTILLE_STATUS.accessionDateTh}
        </li>
        <li>
          <strong>มีผลบังคับใช้กับไทย:</strong> {APOSTILLE_STATUS.inForceDateTh}
        </li>
        <li>
          <strong>หน่วยงานผู้รับรอง:</strong> {APOSTILLE_STATUS.authorityTh}
        </li>
      </ul>
      <p className="mt-3 text-xs text-muted-foreground">
        แหล่งอ้างอิง:{" "}
        {APOSTILLE_STATUS.sources.map((s, i) => (
          <span key={s.url}>
            {i > 0 && " · "}
            <a href={s.url} rel="nofollow noopener" target="_blank" className="underline">
              {s.label}
            </a>
          </span>
        ))}
      </p>
    </aside>
  );
}
